






import Vue from 'vue'
import style from './style.module.scss'

export default Vue.extend({
    name: 'tab-label',
    components: {

    },
    props: {
        active: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            style: style
        }
    },
})
